import React from 'react';

import Container from 'components/Container';
import GridComponent from 'components/Grid';

const Grid: React.FCWithChildren = ({ children }) => {
  return (
    <Container noNestedPadding>
      <GridComponent cols={2}>{children}</GridComponent>
    </Container>
  );
};

export default Grid;
